

import {
  type DraggableEvent,
  type UseDraggableReturn,
  VueDraggable
} from 'vue-draggable-plus'

import { toRaw } from 'vue';

export default {
  name: "rotas-table",
  components: {
    VueDraggable
  },
    props: {
      rotas: {
        type: Array,
        default: () => {
          [];
        },
      },
      motoristas: {
        type: Array,
        default: () => {
          [];
        },
      },
      map: {
        type: Object,
        default: () => {
          return {}; // Retorna um objeto vazio como valor padrão
        },
      },
      alocarMotorista: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      toggleRoute: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      reOrdenar: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      salvarRotas: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      removerRota: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      
      
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
        showConfirmModal:false
      }
    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const setCenter = (rota: any) => {
        if (rota.Operacao && rota.Operacao.latitude && rota.Operacao.longitude) {
          const newLocation = {
            lat: parseFloat(rota.Operacao.latitude),
            lng: parseFloat(rota.Operacao.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }


          props.toggleRoute(rota);
          
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };

      const setCenterItem = (pedido: any) => {
        if (pedido.latitude && pedido.longitude) {
          const newLocation = {
            lat: parseFloat(pedido.latitude),
            lng: parseFloat(pedido.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };



      const toggleRoute = (rota: any) => {
        
        props.toggleRoute(rota);

      }

      const salvarRota = (rota: any) => {
        

        props.salvarRotas(rota);

      }

      const removerRota = (rota: any) => {
        

        props.removerRota(rota);

      }

      const getClassByStatus = (status: Number) => {
          if (status === 0) return 'pedido-item-real-status-desativado'; // Pedido desativado
          if (status === 1) return 'pedido-item-real-status-ativo';     // Pedido ativo
          if (status === 2) return 'pedido-item-real-status-desativado'; // Pedido concluído
          if (status === 5) return 'pedido-item-real-status-desativado'; // Pedido concluído
          return '';
      }

      // Retorna os métodos ou variáveis que você quer expor
      return {

        setCenter,
        setCenterItem,

        toggleRoute,

        salvarRota,
        getClassByStatus,
        removerRota
        
      };
    }
};
